// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#CF0A2C", // Primary -> Main
        contrast: "#FFFFFF", // None, look at primary button text color
        light: "#FF4E6C", // Primary -> Light
        dark: "#A10621", // Primary -> Dark
    },
    secondary: {
        main: "#6D7175", // Secondary -> Main
        contrast: "#FFFFFF", // None, look at secondary button text color
        light: "#A3ADB3", // Secondary -> Light
        dark: "#4C5558", // Secondary -> Dark
    },
    tertiary: {
        main: "#464646", // Tertiary -> Main
        contrast: "#FFFFFF", // None, look at tertiary button text color
        light: "#666666", // Tertiary -> Light
        dark: "#313131", // Tertiary -> Dark
    },
    common: {
        border: "#CCCCCC", // Black & White -> Border
        borderLight: "#E0E0E0", // Black & White -> Border Light
        borderDark: "#666666", // Gray Shades -> Main
        accent: "#F3F3F3", // Gray Shades -> Light
        // accentContrast: "", // Text Color -> Main
        accentContrastLight: "#A7A7A7", // Gray Shades -> Main
        background: "#ffffff", // None, look at website background color
        // backgroundContrast: "", // Text Color -> Main
        disabled: "#CCCCCC", // Gray Shades -> Light
        disabledDark: "#E1E3E4", // Gray Shades -> Mid
    },
    text: {
        main: "#464646", // Text Color -> Main
        accent: "#707679", // Text Color -> Accent
        disabled: "#CCCCCC", // Gray Shades -> Main
        link: "#000000", // Primary -> Main
        linkHover: "#CF0A2C", // Primary -> Dark
        // linkAlt: "", // Text Color -> Main
        linkAltHover: "#CF0A2C", // Primary -> Main
        input: "#000000", // Text Color -> Main
    },
    success: {
        main: "#028526", // Alerts/Contrast -> Success
        contrast: "#FFFFFF", // None, look at text color for the "Alerts/Contrast -> Success" token
        light: "#B6E8C4", // Alerts/Light -> Success
    },
    warning: {
        main: "#AF5C18", // Alerts/Contrast -> Warning
        contrast: "#FFFFFF", // None, look at text color for the "Alerts/Contrast -> Warning" token
        light: "#FFF0E4", // Alerts/Light -> Warning
    },
    danger: {
        main: "#DF1642", // Alerts/Contrast -> Error
        contrast: "#FFFFFF", // None, look at text color for the "Alerts/Contrast -> Error" token
        light: "#FFC3D2", // Alerts/Light -> Error
    },
    info: {
        main: "#666666", // Alerts/Contrast -> Info
        contrast: "#FFFFFF", // None, look at text color for the "Alerts/Contrast -> Info" token
        light: "#EDF5FF", // Alerts/Light -> Info
    },
    neutral: {
        main: "#666666", // None
        contrast: "#FFFFFF", // None
        light: "#E0E0E0", // None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#A7A7A7", // None, look at header search field text color
        // disabled: "", // Text Color -> Disabled
    },
    button: {
        disabled: {
            // These colors should be different than the field disabled styles (common.disabled / text.disabled)
            main: "#e6e6e6", // None
            contrast: "#939393", // None
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#6D7175", // Text Color -> Main
        hover: "#6D7175", // Primary -> Dark
        accent: "#CF0A2C", // Primary -> Main
        accentHover: "#000000", // Primary -> Dark
        accentContrast: "#FFFFFF", // None, should match "primary.contrast"
    },
    menu: {
        mainNavigation: {
            main: "#6D7175", // None, look at main navigation background color
            contrast: "#FFFFFF", // Text Color -> Main
            hover: "#F7F7F7", // Primary -> Main
            accent: "#ffffff", // Primary -> Main
            accentContrast: "#464646", // None, should match "primary.contrast"
            accentHover: "#464646", // Primary -> Main
            border: "#ffffff", // Black & White -> Border
        },
        secondaryNavigation: {
            main: "", // Primary -> Main
            contrast: "#FFFFFF", // None, should match "primary.contrast"
            hover: "#FFFFFF", // None, should match "primary.contrast"
        },
    },
    footer: {
        main: "#6D7175", // Gray Shades -> Light
        contrast: "#FFFFFF", // Text Color -> Main
        alt: "", // Primary -> Main
        altContrast: "#FFFFFF", // None, should match "primary.contrast"
    },
    swatch: {
        main: "", // Black & White -> Border
        contrast: "", // Text Color -> Main
        hover: "", // Primary -> Main
        selected: "", // Primary -> Main
        selectedHover: "", // Primary -> Dark
    },
};

export default colors;
